import * as React from "react";
import OrderListContainer from "../../../components/OrderList/Orders/components/OrderList/OrderListContainer.js";
const Orders = ({ shouldShowOrderDate }) => /* @__PURE__ */ React.createElement("div", { className: "myaccount-orders" }, /* @__PURE__ */ React.createElement(OrderListContainer, { shouldShowOrderDate }));
export {
  Orders as default
};
//# sourceMappingURL=Orders.js.map
